"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _reactQuill = _interopRequireDefault(require("react-quill"));
require("react-quill/dist/quill.core.css");
require("react-quill/dist/quill.snow.css");
require("react-quill/dist/quill.bubble.css");
var _excluded = ["options", "theme"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/**
 * @param {object} options
 * @param {{ 'snow' || 'buble' }} theme
 */
var RichEditor = (0, _react.forwardRef)(function (_ref) {
  var options = _ref.options,
    theme = _ref.theme,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var modulesOptions = {
    toolbar: options
  };
  var defaultOptions = {
    toolbar: [[{
      header: [1, 2, false]
    }], ['bold', 'italic', 'underline', 'strike', 'blockquote'], [{
      list: 'ordered'
    }, {
      list: 'bullet'
    }, {
      indent: '-1'
    }, {
      indent: '+1'
    }], ['link', 'image'], ['clean']]
  };
  return /*#__PURE__*/_react["default"].createElement(_reactQuill["default"], (0, _extends2["default"])({
    modules: modulesOptions || defaultOptions,
    theme: theme || 'bubble'
  }, rest));
});
var _default = RichEditor;
exports["default"] = _default;